import Config from "@skin_config";
import { store } from "../index/terminalApp";
import { getAuthData } from "@common/helpers/auth"
import { TerminalDepositModesEnum } from "../constants/enums/terminalDepositModes";
import { getTerminalBalance } from "./terminalBalance";


export const getMerchantId = () => {
  const authData = getAuthData();

  if (!authData) return ''

  const { tid } = authData

  return Config.main.oktoTestTerminalIds.includes(+tid)
    ? Config.main.oktoTestMerchantId
    : Config.main.oktoMerchantId

}

export const needToShowOctoInactivePopup = () => {
  const terminalState = store.getState().terminal;
  const { depositMode, playerInfo } = terminalState;
  const terminalBalance = getTerminalBalance();

  return ((terminalBalance > 5 && playerInfo?.PersonalId) || depositMode === TerminalDepositModesEnum.Octo)
}